<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function changePage(num) {
        dispatch('page-change', {
            page: num
        });
    }

    export let total;
    export let current = 1;
</script>
<nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
        <li class="page-item" class:disabled={current === 1}>
            <a on:click|preventDefault={() => changePage(current - 1)} class="page-link" class:text-dark={current !== 1 } href="#" tabindex={current === 1 ? '-1' : null}>Precedente</a>
        </li>
        <li class="page-item disabled"><a class="page-link" href="#">{current} di {total}</a></li>
        <li class="page-item" class:disabled={current === total}>
            <a on:click|preventDefault={() => changePage(current + 1)} class="page-link" class:text-dark={current !== total } href="#" tabindex={current === total ? '-1' : null}>Successiva</a>
        </li>
    </ul>
</nav>